import React, {useLayoutEffect, useState} from "react";
import {Menu, message, Tabs} from "antd";
import TabPane from "antd/es/tabs/TabPane";
import {AutoCreate} from "@/pages/account/createApplyLists/sections/AutoCreate";
import {ApplyLists} from "@/pages/account/createApplyLists/sections/ApplyLists";
import {ApplicationFilter} from "@/pages/account/createApplyLists/sections/ApplicationFilter";
import {CompanyApplication} from "@/pages/account/createApplyLists/sections/CompanyApplication";
import {ProfileCard} from "@/pages/account/profile/sections/ProfileCard";
import {profile} from "../createApplyLists/profile";
import {EmptyProfileCard} from "@/pages/account/createApplyLists/components/EmptyProfileCard";
import {MenuOutlined} from "@ant-design/icons";
import ProfileCardMB from "@/pages/account/profile/sections/ProfileSettings/ProfileSettingsMB";

export const CreateApplyLists = () => {
    const [dataed, setDataed] = useState(true);
    const [tab, setTab] = useState("1");
    const MenuItems = [
        {
            key: "1",
            title: "Hồ sơ cá nhân",
        },
        {
            key: "2",
            title: "Hồ sơ công ty",
        },
        {
            key: "3",
            title: "Danh sách tin tuyển dụng",
        },
        {
            key: "4",
            title: "Danh sách ứng viên",
        },
        {
            key: "5",
            title: "Thiết lập tự động",
        },
    ]
    const TabItems = [
        {
            key: "1",
            title: "Hồ sơ công ty",
            compo: <CompanyApplication/>,
        },
        {
            key: "2",
            title: "Danh sách tin tuyển dụng",
            compo: <ApplyLists/>,
        },
        {
            key: "3",
            title: "Danh sách ứng viên",
            compo: <ApplicationFilter/>,
        },
        {
            key: "4",
            title: "Thiết lập tự động",
            compo: <AutoCreate/>,
        },
    ]
    useLayoutEffect(() => {
        if (tab === "5") {
            message.info('Lật ngang thiết bị để trải nghiệm tốt hơn!', 3)
        } else if (tab === "4") {
            message.info('Lật ngang thiết bị để trải nghiệm tốt hơn!', 3)
        }
    }, [tab]);

    return (
        <div className="flex gap-6 p-6 relative bg-gray-100 min-h-screen">
            {/* Sidebar */}
            <div className="w-1/4 hidden lg:block">
                {dataed ? (
                    <ProfileCard profile={profile}/>
                ) : (
                    <EmptyProfileCard/>
                )}
            </div>
            {/* Main Content */}
            <div className="flex-1 hidden lg:block">
                <Tabs rootClassName={"bg-white p-4 rounded-lg shadow-md"} defaultActiveKey="1">
                    {TabItems.map((item) => (
                        <TabPane tab={item.title} key={item.key}>
                            {item.compo}
                        </TabPane>
                    ))}
                </Tabs>
            </div>
            {/*    MOBILE   */}
            <div className={"lg:hidden w-full"}>
                <Menu mode="horizontal"
                      selectedKeys={[setTab]}
                      onClick={(e) => setTab(e.key)}
                      className="bg-white shadow-md rounded-lg mb-4">
                    {MenuItems.map((item) => (
                        <>
                            <Menu.Item key={item.key} icon={<MenuOutlined/>}>
                                {item.title}
                            </Menu.Item>
                        </>
                    ))}
                </Menu>
                <div className="bg-white p-4 rounded-lg shadow-md">
                    {tab === "1" && (
                        <ProfileCardMB profile={profile}/>
                    )}
                    {tab === "2" && (
                        <>
                            <CompanyApplication/>
                        </>
                    )}
                    {tab === "3" && (
                        <>
                            <ApplyLists/>
                        </>
                    )}
                    {tab === "4" && (
                        <>
                            <ApplicationFilter/>
                        </>
                    )}
                    {tab === "5" && (
                        <>
                            <AutoCreate/>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}